import { Component, Input } from '@angular/core';

@Component({
  selector: 'def-loader',
  templateUrl: './def-loader.component.html',
  styleUrls: ['./def-loader.component.scss'],
})
export class DefLoaderComponent {
  @Input() active = false;
}
